import { Button, EmptyView, Paper, TextBase } from '@carboncopyco/ui';
import { useMemo } from 'react';
import { FixedTable } from '../../FixedTable';
import { AssetSelectionSkeleton } from '../../PlaybookModal/AssetSelectionPanel/AssetSelectionSkeleton';
import { useImportManagerState } from '../ImportManagerContext';
import type { TableItem } from '../types';
import { Filters } from './Filters';
import { ImportTableRowWrapper } from './ImportTableRowWrapper';
import { cols } from './cols';

export const DemosSelectionTable = () => {
  const {
    creators,
    query,
    resetFilters,
    isEmpty,
    fetchNextBatch,
    items,
    isLoading,
    isLoadingBatch,
    selectedDemoId,
    currentDemoId,
  } = useImportManagerState();

  const isDirty =
    Object.entries(creators).filter(([, val]) => val).length || query;

  const tableItems = useMemo<TableItem[]>(
    () =>
      (items ?? [])
        .filter((item) => String(item.id) !== currentDemoId)
        .map((item) => {
          return {
            ...item,
            selected: selectedDemoId === item.id,
          };
        }),
    [currentDemoId, items, selectedDemoId]
  );

  return (
    <Paper
      border="ds-regular"
      radius
    >
      <div className="w-[820px] px-2 py-5">
        <Filters />
        {isEmpty && isDirty ? (
          <div className="h-[420px]">
            <EmptyView
              title="No results"
              message={
                <div className="flex flex-col items-center gap-5 ">
                  <TextBase label="Nothing matches your search" />
                  <Button
                    link
                    label="Clear filters"
                    onClick={resetFilters}
                  />
                </div>
              }
            />
          </div>
        ) : (
          <FixedTable<TableItem>
            isLoading={isLoading}
            isLoadingBatch={isLoadingBatch}
            cols={cols}
            data={tableItems}
            rowWrapper={ImportTableRowWrapper}
            handleFetchNextBatch={fetchNextBatch}
            infiniteListMaxHeight={380}
            loader={<AssetSelectionSkeleton count={6} />}
            headerRowClassName="px-3"
          />
        )}
      </div>
    </Paper>
  );
};
